import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { useCallback, useState } from 'react';
import { jsx } from '@emotion/core';
import Popup from '@atlaskit/popup';
import { WidthObserver } from '@atlaskit/width-detector';
import { OverflowProvider, useOverflowController } from '../../controllers/overflow';
import { PrimaryDropdownButton } from '../PrimaryDropdownButton';
import { containerCSS, widthObserverContainerStyle } from './styles';
export const PrimaryItemsContainer = ({
  moreLabel,
  items,
  create: Create,
  theme,
  testId
}) => {
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const {
    updateWidth,
    visibleItems,
    overflowItems
  } = useOverflowController(items);
  const onMoreClick = useCallback(() => {
    setIsMoreOpen(!isMoreOpen);
  }, [isMoreOpen, setIsMoreOpen]);
  const onMoreClose = useCallback(() => {
    setIsMoreOpen(false);
  }, []);
  const openOverflowMenu = useCallback(() => {
    setIsMoreOpen(true);
  }, []);
  const trigger = useCallback(triggerProps => jsx(PrimaryDropdownButton, _extends({
    onClick: onMoreClick,
    isSelected: isMoreOpen,
    testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger'
  }, triggerProps), moreLabel), [moreLabel, onMoreClick, isMoreOpen, testId]);

  const WidthObserverRelativeWrapper = () => {
    return jsx("div", {
      style: widthObserverContainerStyle
    }, jsx(WidthObserver, {
      offscreen: true,
      setWidth: updateWidth
    }));
  };

  const content = useCallback(() => jsx(OverflowProvider, {
    isVisible: false,
    openOverflowMenu: openOverflowMenu,
    closeOverflowMenu: onMoreClose
  }, overflowItems), // Overflow items has an unstable reference - so we will only recalculate
  // content if `overflowItems` length changes.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [overflowItems.length, openOverflowMenu, onMoreClose]);
  return jsx("div", {
    css: containerCSS(theme),
    "data-testid": testId && `${testId}-primary-actions`
  }, jsx(OverflowProvider, {
    isVisible: true,
    openOverflowMenu: openOverflowMenu,
    closeOverflowMenu: onMoreClose
  }, visibleItems), overflowItems.length > 0 && jsx(Popup, {
    placement: "bottom-start",
    content: content,
    isOpen: isMoreOpen,
    onClose: onMoreClose,
    trigger: trigger,
    testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
  }), Create && jsx(Create, null), jsx(WidthObserverRelativeWrapper, null));
};